<template>
  <div class="page">
    <nut-textinput placeholder="请输入8986开头ICCID号" id="inputTest" ref="inputTest"  maxlength="20" v-model.trim="iccid" @focus="focusfns" @input="monitor()"/>
    <div class="search_main" v-show="According">
      <ul>
        <li v-for="(item,index) in newhistoryList" :key="index" @click="goSearchDetail(item)">
          <span class="i-search"></span>
          <span class="em">{{item}}</span>
        </li>
      </ul>
      <div class="search_bottom">
        <span @click="empty">清空数据</span>
        <span @click="close" style="float:right">关闭</span>
      </div>
    </div>
    <nut-button block @click="query" class="cx-class">查询</nut-button>
    <nut-button block @click="handleScanCode" class="sm_class">扫码查询</nut-button>
    <div class="div_class">
      <div class="search-info">
        <p class="p1">温馨提示: 系统会记住您最近查询成功的号码</p>
        <img src="../assets/img/qrcode.png" alt />
        <p class="p1">点击"扫码输入", 对着卡的条形码扫一扫</p>
      </div>
      <div class="focus-on" v-if="!gykj">
        <span>长按识别下方图片关注公众号</span>
        <img src="../assets/img/ggh.jpg" alt="" style="width:28%" v-if="jz">
        <img src="../assets/img/gghzw.jpg" alt="" style="width:28%" v-if="zw">
        <img src="../assets/img/gghyl.jpg" alt="" style="width:28%" v-if="yl">
        <img src="../assets/img/bf.jpg" alt="" style="width:28%" v-if="bf">
        <img src="../assets/img/wst.jpg" alt="" style="width:28%" v-if="wst">
        <img src="../assets/img/hywl.jpg" alt="" style="width:28%" v-if="hywl">
        <img src="../assets/img/gjhl.jpg" alt="" style="width:28%" v-if="gjhl">
        <img src="../assets/img/wbz.jpg" alt="" style="width:28%" v-if="wbz">
      </div>
    </div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import { wx_Auth } from "@/api/api.js"; //获取微信信息
import { wx_validate } from "@/api/api.js"; //查询卡
import { wx_record } from "@/api/api.js"; //获取微信查询记录
import { wx_clear } from "@/api/api.js"; //获取微信查询记录
export default {
  data() {
    return {
      jz:false,
      zw:false,
      yl:false,
      bf:false,
      wst:false,
      gykj:false,
      hywl:false,
      gjhl:false,
      wbz:false,
      iccid:"",
      code:null,
      historyList: [],
      newhistoryList:[],
      datas:{},
      According: false,
    };
  },
  methods: {
    monitor(){
      const newarr =[];
      this.historyList.forEach(item=>{
        if(item.indexOf(this.iccid) > -1){
          newarr.push(item);
        }
      });
      this.newhistoryList = newarr;
    },
    goSearchDetail(item){
      this.iccid = item;
      this.According = false;
      document.getElementById("inputTest").querySelector(".nut-textinput-clear").style.display = "block";
    },
    // input光标聚焦
    focusfns() {
      this.According = true;
      this.newhistoryList = this.historyList;
    },
    // 清空历史记录
    empty(){
      let params = {
        code: this.code,
        channel:this.getUrlParam("channel")
      };
      wx_clear(params).then(res => {
        if (res.data.code == 200) {
          this.$toast.success('清空成功!');
          setTimeout(()=>{
            location.reload();
          },1000)
        }
      })
    },
    // 历史记录关闭
    close(){
      this.According = false;
    },
    //获取微信信息
    handelWxConfig() {
      let reqUrl = window.location.href;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端 
      if (isiOS) {
        reqUrl = window.location.href.split('#')[0];
      }
      let params = {
        url:reqUrl,
        channel:this.getUrlParam("channel")
      };
      wx_Auth(params).then(res => {
        let dataObj = res.data.data;
        this.datas = res.data.data;
        let getAppid = dataObj.appId;
        let getTimestamp = dataObj.timestamp;
        let getNonceStr = dataObj.nonceStr;
        let getSignature = dataObj.signature;
        wx.config({
          debug: false,
          appId: getAppid,
          timestamp: getTimestamp,
          nonceStr: getNonceStr,
          signature: getSignature,
          jsApiList: ["scanQRCode"]
        });
        wx.ready(function() {
          wx.checkJsApi({
            jsApiList: ["scanQRCode"],
            success: function(res) {}
          });
        });
      });
    },
    // 扫码查询
    handleScanCode() {
      let that = this;
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: function(res) {
          var result = res.resultStr.split(",");
          that.iccid = result[1] ? result[1]:result[0];
        }
      });
    },
    // 查询按钮
    query(){
      if(!this.iccid){
        this.$toast.warn('请输入ICCID号');
      }else{
        let params ={
          iccid:this.iccid,
          channel:localStorage.getItem("channel")
        };
        params.code = this.code;
        wx_validate(params).then(res => {
          if (res.data.code == 200) {
            this.$router.push({
              name: "info",
              query: {
                iccid: res.data.data,
              }
            });
          }else{
            this.$toast.fail(res.data.message);
          }
        })
      }
    },
    // 获取微信记录
    getWxjilu(){
      if(this.getUrlParam("channel") == "jz"){
        this.jz = true
      }else if(this.getUrlParam("channel") == "zw"){
        this.zw = true
      }else if(this.getUrlParam("channel") == "qhyl"){
        this.yl = true
      }else if(this.getUrlParam("channel") == "yl"){
        this.yl = true
      }else if(this.getUrlParam("channel") == "wx1"){
        this.bf = true
      }else if(this.getUrlParam("channel") == "wx2"){
        this.wst = true
      }else if(this.getUrlParam("channel") == "gykj"){
        this.gykj = true
      }else if(this.getUrlParam("channel") == "hywl"){
        this.hywl = true
      }else if(this.getUrlParam("channel") == "gjhl"){
        this.gjhl = true
      }else{
        this.jz = true
      };
      localStorage.setItem("channel",this.getUrlParam("channel")=='yl'?'qhyl':this.getUrlParam("channel"));
      let params ={
        code:this.code,
        channel:localStorage.getItem("channel")
      };
      wx_record(params).then(res => {
        var query = window.location.href;
        if(query.indexOf("iccid") !== -1){
          this.iccid = this.$route.query.iccid;
          if(this.iccid == '898604A2192180522250'){
            this.iccid ='';
          }
        }else{
          if(res.data.data.length > 0) {
            this.historyList = res.data.data;
            this.iccid = res.data.data[0];
            document.getElementById("inputTest").querySelector(".nut-textinput-clear").style.display = "block";
          }
        }
      })
    },
    // 获取code
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let url = window.location.href;
      let search = url.split("?")[1];
      if (search) {
        var r = search.substr(0).match(reg);
        if (r !== null) return unescape(r[2]);
        return null;
      } else {
        return null;
      }
    },
  },
  created() {
    this.handelWxConfig();
    this.code = this.getUrlParam("code");
    localStorage.setItem("code",this.code);
    this.getWxjilu();
  },
  mounted(){
    window.document.title = "流量查询";
  }
};
</script>
<style scoped lang="less">
.page{
  .search_main {
    width: 95%;
    border: 1px solid #dcdfe6;
    position: relative;
    top: 0px;
    left: 9px;
    z-index: 2;
    background: #fff;
    border-radius: 3px 3px 0 0;
  }
  .search_main ul {
    width: 100%;
    min-height: 40px;
    max-height: 120px;
    overflow-y:scroll;
    overflow-x:scroll;
  }
  .search_main ul li {
    height: 40px;
    line-height: 40px;
    color: #606266;
    border-bottom: 1px solid #f0f0f0;
    word-break: break-all;
    font-size: 16px;
  }
  .search_main ul li .em {
    padding-left: 10px;
    color: #999;
  }
  .search_bottom {
    height: 40px;
    line-height: 40px;
    background: #f7f7f7;
    padding: 0 10px;
    span{
      color: #999;
    }
  }
  .i-search {
    background-image: url(../assets/img/search.png);
    display: inline-block;
    width: 20px;
    height: 20px;
    background-size: 100%;
    vertical-align: middle;
    margin: 0 6px 0 10px;
  }
  padding: 40px 30px 0px 30px;
  /deep/ .nut-textinput{
    margin: 0 auto;
    width: 95%;
    border: 2px solid #F94040;
    height: 45px;
    line-height: 41px;
    border-radius: 5px;
    input{
      border: 1px solid #fff;
      font-size: 15px;
    }
  }
  /deep/ .nut-button.block{
    margin: 25px auto;
    width:95%;
    display: block;
    height: 45px;
    font-size: 16px;
    border-radius:5px;
  }
  .p-chaxun{
    margin: 25px auto;
    width:95%;
    height: 45px;
    border-radius:5px;
    position: relative;
    img{
      width: 100%;
      height: 45px;
      border-radius:5px;
    }
    span{
      font-size: 16px;
      color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
  }
  .div_class{
    margin-top: 35px;
  }
  .div_class p{
    margin-top: 10px;
    font-size: 12px;
  }
  .p_c{
    color:#F24F00;
  }
  .cx-class{
    background: #f94040 !important;
    border: 1px solid #f94040 !important;
  }
  .sm_class{
    background: #fff !important;
    color: #f94040;
    border: 1px solid #f94040;
    box-shadow: inset 0 0 3px 0 #f94040;
  }
  .search-info {
    text-align: center;
  }
  .search-info .p1 {
    font-weight: bold;
    font-size: 16px;
  }
  .search-info img {
    width: 70%;
  }
  .focus-on {
    margin-top: 20px;
    text-align: center;
  }
  @-webkit-keyframes dongHua {
    0% {
        color: #6F09CD;
    }
    10% {
        color: #5C86FF;
    }
    30% {
        color: #5EB1DB;
    }
    60% {
        color: #10D219;
    }
    80% {
        color: #EFC139;
    }
    100% {
        color: #EBA46D;
    }
  }
  .focus-on span {
    width: 100%;
    height: 40px;
    display: block;
    margin: 0 auto;
    line-height: 40px;
    font-size: 16px;
    -webkit-animation: dongHua 2s ease-in-out infinite normal;
    animation: dongHua 2s ease-in-out infinite normal;
    font-weight: 700;
  }
}
</style>

